import { ChevronLeft, ChevronRight } from 'lucide-react'
import { Button } from '../ui/Button.js'
import { Row } from '../layout/Stack.js'
import { Text } from '../ui/Typography.js'

export interface PaginationProps {
  /** Null when there is no further page — the API answers with a cursor or nothing. */
  nextCursor: string | null
  /** The cursors already visited, so Back is a real step rather than a guess. */
  history: string[]
  onNext: () => void
  onBack: () => void
  /** "Showing 50" — a count of what is on screen, never an invented total. */
  showing: number
  loading?: boolean
}

/**
 * Next and back, over a cursor.
 *
 * Deliberately not numbered pages: the API pages by cursor, so "page 7" is not a
 * thing anybody can ask it for, and drawing seven numbers would mean inventing six
 * requests that cannot be made.
 */
export function Pagination({
  nextCursor,
  history,
  onNext,
  onBack,
  showing,
  loading,
}: PaginationProps) {
  if (!nextCursor && history.length === 0) return null
  return (
    <Row justify="between" className="pt-1">
      <Text variant="caption">Showing {showing}</Text>
      <Row gap={2}>
        <Button
          variant="secondary"
          size="sm"
          onClick={onBack}
          disabled={history.length === 0 || loading}
          leadingIcon={<ChevronLeft />}
        >
          Back
        </Button>
        <Button
          variant="secondary"
          size="sm"
          onClick={onNext}
          disabled={!nextCursor || loading}
          trailingIcon={<ChevronRight />}
        >
          Next
        </Button>
      </Row>
    </Row>
  )
}
